<script>
export let msg_show;
export let msg_text;
export let msg_type;
export let successfully_submitted;



let conferences = [
	{
		id: 20,
		name: 'Atlantic (Selects)'
	},
	{
		id: 18,
		name: 'Nova Scotia (Selects)',
	},
	{
		id: 17,
		name: 'New Brunswick (Selects)',
	},
	{
		id: 16,
		name: 'Nova Scotia (Young Guns)',
	},
	{
		id: 15,
		name: 'New Brunswick (Young Guns)',
	},
];


let divisions = [
	{
		id: 117,
		name: '2010 Atlantic',
		conference_id: 20,
	},
	{
		id: 116,
		name: '2011 Atlantic',
		conference_id: 20,
	},
	{
		id: 101,
		name: "2015 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 108,
		name: "2016 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 106,
		name: "2010 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 105,
		name: "2011 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 104,
		name: "2012 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 103,
		name: "2013 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 102,
		name: "2014 (Nova Scotia Selects)",
		conference_id: 18
	},
	{
		id: 95,
		name: "2015 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 96,
		name: "2013 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 97,
		name: "2014 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 98,
		name: "2012 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 99,
		name: "2011 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 100,
		name: "2010 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 107,
		name: "2016 (New Brunswick Selects)",
		conference_id: 17
	},
	{
		id: 94,
		name: "U18 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 83,
		name: "U11 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 82,
		name: "U11 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 88,
		name: "U13 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 87,
		name: "U13 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 89,
		name: "U15 Tier 1 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 90,
		name: "U15 Tier 2 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 80,
		name: "U9 (Nova Scotia Young Guns)",
		conference_id: 16
	},
	{
		id: 114,
		name: 'U9 Tier 1 (Nova Scotia Young Guns)',
		conference_id: 16,
	},
	{
		id: 113,
		name: 'U9 Tier 2 (New Brunswick Young Guns)',
		conference_id: 15,
	},
	{
		id: 91,
		name: "U15 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 81,
		name: "U11 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 85,
		name: "U13 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 84,
		name: "U11 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 86,
		name: "U13 Tier 2 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 79,
		name: "U9 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 92,
		name: "U15 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 93,
		name: "U18 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15
	},
	{
		id: 112,
		name: "U9 Tier 1 (New Brunswick Young Guns)",
		conference_id: 15
	}
]



let team_instances = [
	{
		division_id: 117,
		conference_id: 20,
		id: 1641,
		name: "Selects",
	},
	{
		division_id: 116,
		conference_id: 20,
		id: 1640,
		name: "Selects",
	},
	{
  		division_id: 108,
  		conference_id: 18,
  		id: 1633,
  		name: "Selects"
	},
	{
  		division_id: 107,
  		conference_id: 17,
  		id: 1626,
  		name: "Selects"
	},
	// {
  	// 	division_id: 93,
  	// 	conference_id: 15,
  	// 	id: 1118,
  	// 	name: "Young Guns"
	// },
	{
  		division_id: 89,
  		conference_id: 16,
  		id: 1625,
  		name: "Young Guns (Coach Lamrock)"
	},
	{
  		division_id: 89,
  		conference_id: 16,
  		id: 1624,
  		name: "Young Guns (Coach Eisnor)"
	},
	// {
  	// 	division_id: 94,
  	// 	conference_id: 16,
  	// 	id: 1116,
  	// 	name: "Young Guns"
	// },
	{
  		division_id: 90,
  		conference_id: 16,
  		id: 1621,
  		name: "Young Guns"
	},
	{
  		division_id: 87,
  		conference_id: 16,
  		id: 1620,
  		name: "Young Guns"
	},
	{
  		division_id: 88,
  		conference_id: 16,
  		id: 1619,
  		name: "Young Guns"
	},
	{
  		division_id: 82,
  		conference_id: 16,
  		id: 1618,
  		name: "Young Guns"
	},
	{
  		division_id: 83,
  		conference_id: 16,
  		id: 1617,
  		name: "Young Guns"
	},
	{
		division_id: 114,
		conference_id: 16,
		id: 1616,
		name: "Young Guns",
	},
	{
		division_id: 113,
		conference_id: 15,
		id: 1615,
		name: "Young Guns",
	},
	{
		division_id: 112,
		conference_id: 15,
		id: 1614,
		name: "Young Guns",
	},
	// {
  	// 	division_id: 80,
  	// 	conference_id: 16,
  	// 	id: 1110,
  	// 	name: "Young Guns"
	// },
	{
  		division_id: 84,
  		conference_id: 15,
  		id: 1608,
  		name: "Young Guns"
	},
	{
  		division_id: 91,
  		conference_id: 15,
  		id: 1609,
  		name: "Young Guns"
	},
	{
  		division_id: 92,
  		conference_id: 15,
  		id: 1610,
  		name: "Young Guns"
	},
	{
  		division_id: 86,
  		conference_id: 15,
  		id: 1611,
  		name: "Young Guns"
	},
	{
  		division_id: 85,
  		conference_id: 15,
  		id: 1612,
  		name: "Young Guns"
	},
	{
  		division_id: 81,
  		conference_id: 15,
  		id: 1613,
  		name: "Young Guns"
	},
	// {
  	// 	division_id: 79,
  	// 	conference_id: 15,
  	// 	id: 1103,
  	// 	name: "Young Guns"
	// },
	{
  		division_id: 101,
  		conference_id: 18,
  		id: 1634,
  		name: "Selects"
	},
	{
  		division_id: 102,
  		conference_id: 18,
  		id: 1635,
  		name: "Selects"
	},
	{
  		division_id: 103,
  		conference_id: 18,
  		id: 1636,
  		name: "Selects"
	},
	{
  		division_id: 104,
  		conference_id: 18,
  		id: 1637,
  		name: "Selects"
	},
	{
  		division_id: 105,
  		conference_id: 18,
  		id: 1638,
  		name: "Selects"
	},
	{
  		division_id: 106,
  		conference_id: 18,
  		id: 1639,
  		name: "Selects"
	},
	{
  		division_id: 95,
  		conference_id: 17,
  		id: 1627,
  		name: "Selects"
	},
	{
  		division_id: 97,
  		conference_id: 17,
  		id: 1628,
  		name: "Selects"
	},
	{
  		division_id: 96,
  		conference_id: 17,
  		id: 1629,
  		name: "Selects"
	},
	{
  		division_id: 98,
  		conference_id: 17,
  		id: 1630,
  		name: "Selects"
	},
	{
  		division_id: 99,
  		conference_id: 17,
  		id: 1631,
  		name: "Selects"
	},
	{
  		division_id: 100,
  		conference_id: 17,
  		id: 1632,
  		name: "Selects"
	}
]



import { get } from 'svelte/store';
import { createForm } from 'svelte-forms-lib';
import * as yup from 'yup';
import { navigateTo, Navigate } from 'svelte-router-spa';

import { onMount } from 'svelte';


import MsgCard from 'components/elements/MsgCard.svelte';



import FormFieldError from 'components/forms/FormFieldError.svelte';



const forms_api_url = app_.env.FORMS_API_URL;

const hcaptcha_site_key = app_.env.HCAPTCHA_SITE_KEY;


let captcha;



let loading = false;



let active_conference_id;

let active_division_id;


let active_conferences = conferences;

let active_divisions = divisions;

let active_team_instances = team_instances;


const {
	form,
	errors,
	state,
	// handleBlur,
	handleChange,
	handleSubmit,
	setField,
} = createForm({
	initialValues: {
		team_instance_id: null,
		contact_email: '',
		contact_phone_number: '',
		player_full_name: '',
		// mailing_address_cheque: '',

		jersey_sponsors: [
			{
				name_of_sponsor: '',
				no_sponsor_bar: false,
				sponsor_line_1: '',
				sponsor_line_2: '',
				amount: null,
			},
		],
	},
	validationSchema: yup.object().shape({
		team_instance_id: yup
			.number()
			.required('Must be a valid team!'),
		contact_email: yup
			.string()
			.email('Must be a valid email!')
			.required('Email required!'),
		contact_phone_number: yup
			.string()
			.required('Phone number required!'),

		player_full_name: yup
			.string()
			.required('Player name required!'),

		// mailing_address_cheque: yup
		// 	.string()
		// 	.required('Mailing Address Cheque'),

		jersey_sponsors: yup
			.array()
			.of(
				yup.object().shape({
					name_of_sponsor: yup
								.string()
								.required('Name of sponsor required!'),
					no_sponsor_bar: yup
									.bool()
									.nullable(),
					sponsor_line_1: yup
									.string()
									.max(20, '20 Characters Maximum!')
									.test(
										'not-no-sponsor-bar',
										'You selected no sponsor bar!',
										function(v) {
											if (!!this.parent.no_sponsor_bar) {
												return (!v);
											}
											return true;
										}
									),
					sponsor_line_2: yup
									.string()
									.max(20, '20 Characters Maximum!')
									.test(
										'not-no-sponsor-bar',
										'You selected no sponsor bar!',
										function(v) {
											if (!!this.parent.no_sponsor_bar) {
												return (!v);
											}
											return true;
										}
									)
									.test(
										'sponsor-line-1-must-be-given',
										'Sponsor line 1 must be given',
										function(v) {
										if (!this.parent.sponsor_line_1) {
											return (!v);
										}
										return true;
									}),
					amount: yup
							.number()
							.typeError('Must be valid amount!')
							.required('Must be valid amount!')
							// .nullable()
							.label('Tag'),
				}),
			)
			.label(''),

		'h-captcha-response': yup
			.string()
			.required(),
	}),
	onSubmit: values => {

		confirm('Do you confirm your jersey sponsor(s) order?');

		loading = true;

		console.log(JSON.stringify(values));

		let body_data = JSON.stringify(values);

		console.log(body_data);

		submitForm(body_data).then(data => {

			msg_type = 'success';
			msg_show = true;
			msg_text = '...';

			successfully_submitted = true;

		}).catch(error => {

			msg_type = 'error';
			msg_show = true;

		}).finally(() => {

			loading = false;

		});

	}
});



$: {
	console.log(active_conference_id);
	active_division_id = '';
	$form.team_instance_id = '';
	active_divisions = divisions.filter(el => el.conference_id == active_conference_id);
}



$: {
	console.log(active_division_id);
	$form.team_instance_id = '';
	active_team_instances = team_instances.filter(el => el.division_id == active_division_id);
	if (active_team_instances.length === 1) {
		$form.team_instance_id = active_team_instances[0].id;
	}
}



async function submitForm(body_data) {

	// alert('here!')

	// const url = `${forms_api_url}/_submit/team-instance-jersey-sponsor-orders/${season_instance.id}`;
	const url = 'https://ahg-serv-misc.vercel.app/api/v1/_forms/form/team-instance-jersey-sponsor-order';

	console.log(url);

	const resp = await fetch(url, {
		method: 'POST',
		body: body_data,
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const result = await resp.json();

	console.log(resp);
	console.log(result);

	if (!resp.ok) {
		msg_text = result.detail;
		throw new Error('Error!');
	}

	return result;

}



onMount(() => {
	// Append hCaptcha Script
	const loadhCaptcha = (callback) => {
		const existingScript = document.getElementById('hCaptcha');
		if (!existingScript) {
			const script = document.createElement('script');
			script.src = 'https://hcaptcha.com/1/api.js?recaptchacompat=off&render=explicit';
			script.id = 'hCaptcha';
			document.body.appendChild(script);
			script.onload = () => {
				if (callback) callback();
			};
		}
		if (existingScript && callback) callback();
	};

	// Render hCaptcha
	const injecthCaptcha = () => {
		hcaptcha.render(captcha, {
			theme: 'light',
			sitekey: hcaptcha_site_key,
			recaptchacompat: false,
			callback: (token) => {
				$form['h-captcha-response'] = token;
			},
			'expired-callback': (token) => {
				// $form['h-captcha-response'] = token;
			},
			'error-callback': (token) => {
				// $form['h-captcha-response'] = token;
			}
		});
	};
	// Run load and provide callback
	loadhCaptcha(() => {
		injecthCaptcha();
	});
});



function addNewJerseySponsor() {

	$form.jersey_sponsors = [...$form.jersey_sponsors, {
		name_of_sponsor: '',
		no_sponsor_bar: false,
		sponsor_line_1: '',
		sponsor_line_2: '',
		amount: null,
	}];


}


function removeJerseySponsor(i) {

	// ---
	$form.jersey_sponsors.splice(i, 1);

	$form.jersey_sponsors = $form.jersey_sponsors;

	$errors.jersey_sponsors.splice(i, 1);

	$errors.jersey_sponsors = $errors.jersey_sponsors;

	// console.log($errors.jersey_sponsors);

}



</script>


<style>

form {

}

</style>


<form on:submit={handleSubmit}>

	<div class="field">

		<div class="control">

			<label>
				Conference
			</label>

			<div class="select is-fullwidth">

				<select bind:value={active_conference_id} disabled={loading}>

					<option value="">
						Team Conference
					</option>

					{#each active_conferences as conference}

						<option value="{conference.id}">
							{conference.name}
						</option>

					{/each}
					
				</select>

			</div>

		</div>

	</div>


	{#if !!active_conference_id}

	<div class="field">

		<div class="control">

			<label>
				Division
			</label>

			<div class="select is-fullwidth">

				<select bind:value={active_division_id} disabled={loading}>

					<option value="">
						Team Division
					</option>

					{#each active_divisions as division}

						<option value="{division.id}">
							{division.name}
						</option>

					{/each}
					
				</select>

			</div>

		</div>

	</div>

	{#if !!active_division_id}

	<div class="field">

		<div class="control">

			<label>
				Team
			</label>

			<div class="select is-fullwidth">

				<select bind:value={$form.team_instance_id} disabled={loading}>

					<option value="">
						Team
					</option>

					{#each active_team_instances as team_instance}
						<option value="{team_instance.id}">
							{team_instance.name}
						</option>
					{/each}

				</select>

			</div>

			{#if $errors.team_instance_id}
				<FormFieldError detail={'Select a valid team!'} />
			{/if}

		</div>

	</div>


	<br>


	{#if !!$form.team_instance_id}

	<!-- Actual form data! -->

	<div class="field">

		<div class="control">

			<label>
				Contact Email
			</label>

			<input placeholder="Contact Email" class="input" type="text" id="contact_email" name="contact_email" on:change={handleChange} bind:value={$form.contact_email} disabled={loading}>

			{#if $errors.contact_email}
				<FormFieldError detail={$errors.contact_email} />
			{/if}

		</div>

	</div>


	<div class="field">

		<div class="control">

			<label>
				Contact Phone #
			</label>

			<input placeholder="Contact Phone #" class="input" type="text" id="contact_phone_number" name="contact_phone_number" on:change={handleChange} bind:value={$form.contact_phone_number} disabled={loading}>

			{#if $errors.contact_phone_number}
				<FormFieldError detail={$errors.contact_phone_number} />
			{/if}

		</div>

	</div>


	<div class="field">

		<div class="control">

			<label>
				Player Full Name
			</label>

			<input placeholder="Player Full Name" class="input" type="text" id="player_full_name" name="player_full_name" on:change={handleChange} bind:value={$form.player_full_name} disabled={loading}>

			{#if $errors.player_full_name}
				<FormFieldError detail={$errors.player_full_name} />
			{/if}

		</div>

	</div>



	<!-- --- -->
	<br>
	<br>

	<MsgCard msg_show={true} msg_text={"Please note that players can only have two lines of text of 14 characters per line maximum for their sponsor bar. Players can only have one sponsor bar per jersey. Please arrange the text for your sponsor before entering it on this sheet.<br><br>Veuillez noter que les joueurs ne peuvent avoir que deux lignes de texte de 14 caractères maximum par ligne pour leur barre de parrainage. Les joueurs ne peuvent avoir qu'une seule barre de sponsor par maillot. Veuillez arranger le texte pour votre parrain avant de l'inscrire sur cette feuille."} msg_type={'error'} msg_forever={true} />


	{#each $form.jersey_sponsors as jersey_sponsor, i}

		<div class="field">

			<div class="control">

				<div class="columns is-variable is-vcentered is-2">

					<div class="column">
						<label style="margin-bottom: 0 !important; font-size: 1.225rem !important; color: #3c3c3c;">
							Sponsor {i + 1}
						</label>
					</div>

					<div class="column is-narrow">
						{#if $form.jersey_sponsors.length === 1}
						<span class="button is-custom-red is-small is-invisible" style="margin-top: 0 !important;">
							Remove
						</span>
						{:else}
						<span class="button is-custom-red is-small" style="margin-top: 0 !important;" on:click={() => removeJerseySponsor(i)}>
							Remove
						</span>
						{/if}
					</div>

				</div>

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Name of Sponsor" class="input" type="text" id="jersey_sponsors.{i}.name_of_sponsor" name="jersey_sponsors.{i}.name_of_sponsor" on:change={handleChange} bind:value={$form.jersey_sponsors[i].name_of_sponsor} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].name_of_sponsor}
					<FormFieldError detail={$errors.jersey_sponsors[i].name_of_sponsor} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<label class="checkbox">
					<input type="checkbox" bind:checked={$form.jersey_sponsors[i].no_sponsor_bar} on:change={handleChange} style="margin-right: 0.5rem;" disabled={loading}>
					No Sponsor Bar?
				</label>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].no_sponsor_bar}
					<FormFieldError detail={$errors.jersey_sponsors[i].no_sponsor_bar} />
					{/if}
				{/if}

			</div>

		</div>


		<!-- -- -->


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Line 1" class="input" type="text" id="jersey_sponsors.{i}.sponsor_line_1" name="jersey_sponsors.{i}.sponsor_line_1" on:change={handleChange} bind:value={$form.jersey_sponsors[i].sponsor_line_1} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].sponsor_line_1}
					<FormFieldError detail={$errors.jersey_sponsors[i].sponsor_line_1} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Line 2" class="input" type="text" id="jersey_sponsors.{i}.sponsor_line_2" name="jersey_sponsors.{i}.sponsor_line_2" on:change={handleChange} bind:value={$form.jersey_sponsors[i].sponsor_line_2} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].sponsor_line_2}
					<FormFieldError detail={$errors.jersey_sponsors[i].sponsor_line_2} />
					{/if}
				{/if}

			</div>

		</div>


		<div class="field">

			<div class="control">

				<input placeholder="Sponsor Amount" class="input" type="number" id="jersey_sponsors.{i}.amount" name="jersey_sponsors.{i}.amount" on:change={handleChange} bind:value={$form.jersey_sponsors[i].amount} disabled={loading}>

				{#if $errors.jersey_sponsors[i]}
					{#if $errors.jersey_sponsors[i].amount}
					<FormFieldError detail={$errors.jersey_sponsors[i].amount} />
					{/if}
				{/if}

			</div>

		</div>


		{#if $form.jersey_sponsors.length > 1 && i !== $form.jersey_sponsors.length - 1}
		<hr style="">
		{/if}


	{/each}



	<!-- breaker ..? -->



	<div class="button is-small is-custom" style="margin-top: 1rem !important;" on:click={addNewJerseySponsor}>
		Add Another Sponsor
		<i class="far fa-plus" style=""></i>
	</div>

	<br>

	<br>

	<!-- --- -->

	{/if}

	{/if}

	{/if}

	<br class:is-hidden={!$form.team_instance_id}>

	<div class="field" class:is-hidden={!$form.team_instance_id}>

		<div class="control">

			<div bind:this={captcha} />

			{#if $errors['h-captcha-response']}
				<FormFieldError detail={"Prove you're not a bot!"} />
			{/if}

		</div>

	</div>

	<br class:is-hidden={!$form.team_instance_id}>

	<div class="field" class:is-hidden={!$form.team_instance_id}>

		<div class="control">

			<button class="button is-blue is-fullwidth" disabled={loading}>
				<span>Submit Form</span>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!loading}></i>
			</button>

		</div>

		<!-- <div class="control">

			<Navigate styles="form-card-link" to="/code/send-new">
				<span>Forgot Code or Email?</span>
			</Navigate>

		</div> -->

	</div>


</form>




